import { render, staticRenderFns } from "./TeamAttacher.vue?vue&type=template&id=2d11ca1a&"
import script from "./TeamAttacher.vue?vue&type=script&lang=js&"
export * from "./TeamAttacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports